<h2 mat-dialog-title>
  {{ data.title | translate: { param1: data.paramTitle?.param1 ?? '', param2: data.paramTitle?.param2 ?? '', param3:
  data.paramTitle?.param3 ?? '' } }}
</h2>

<div mat-dialog-content>
  <p>
    {{ data.message | translate:{ mparam: data.paramMessage?.param1 ?? '', param2: data.paramMessage?.param2 ?? '',
    param3: data.paramMessage?.param3 ?? '' } }}
  </p>
  <p>{{ data.requireName | translate }} <strong>{{ data.requiredString }}</strong></p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ data.requireInputLabel | translate }}</mat-label>
    <input matInput [formControl]="confirmControl" autocomplete="off">
    <mat-error v-if="confirmControl.hasError('mismatch')">
      {{ data.requireInputError | translate }}
    </mat-error>
  </mat-form-field>

  <!-- Reason (optional/required) -->
  @if (showReason) {
  <p>{{ data.reasonText| translate }}</p>
  <mat-form-field *ngIf="showReason" appearance="outline" class="full-width">
    <mat-label>{{ (data.reasonInputLabel) | translate }}</mat-label>
    <textarea matInput [formControl]="reasonControl" rows="3"></textarea>
    <mat-error *ngIf="isReasonRequired && reasonControl.hasError('required')">
      {{ data.reasonInputError | translate }}
    </mat-error>
  </mat-form-field>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="buildResult(false)">
    {{ data.cancelText | translate }}
  </button>

  <button mat-raised-button color="warn" [mat-dialog-close]="buildResult(true)" [disabled]="confirmControl.invalid || (showReason && reasonControl.invalid)">
    {{ data.confirmText | translate }}
  </button>
</div>